export enum CustomTemplateFramework {
	formioBootstrap = 'FormioBootstrap'
}
